import Navbar from "../components/global-components/navbar-v4";
import PageHeader from "../components/global-components/page-header";
import MyAccount from "../components/shop-components/my-account";

function Akun() {
	return (
		<div>
			<Navbar CustomClass="ltn__header-transparent gradient-color-2" />
			<PageHeader headertitle="Akun Saya" />
			<MyAccount />
		</div>
	);
}

export default Akun;
